import { makeStyles, tokens } from "@fluentui/react-components";
import { iconFilledClassName } from "@fluentui/react-icons";
import { highContrastHighlightStyles } from "./sharedStyles";

export const useStyles = makeStyles({
  spinnerLabel: {
    whiteSpace: "nowrap",
    ...highContrastHighlightStyles,
  },
  overflowMenuButton: {
    "--colorSubtleBackgroundSelected": tokens.colorBrandBackground2,
    "--colorSubtleBackgroundHover": tokens.colorBrandBackground2,
    "--colorSubtleBackgroundPressed": tokens.colorBrandBackground2,
    ":focus-visible": {
      backgroundColor: tokens.colorBrandBackground2,
    },
    ...highContrastHighlightStyles,
  },
  overflowMenuIcon: {
    [`&.${iconFilledClassName}`]: {
      color: tokens.colorBrandForeground1,
      ...highContrastHighlightStyles,
    },
    ...highContrastHighlightStyles,
  },
});
